<template>
  <el-form v-loading="fetchLoading" class="c-cabinet-shipment-detail" label-position="top">
    <!-- 基本信息 -->
    <c-info-card id="basicInfo" class="basic-info" title="基本信息">
      <c-form-items :showOperation="false" :items="BasicInfoFormItems" :model="detailData" />
    </c-info-card>
    <el-tabs v-model="operateActiveName" @tab-click="handleClickTab">
      <el-tab-pane label="运单信息" name="WaybillInfo">
        <c-info-card title="快递信息">
          <c-form-items :showOperation="false" :items="ExpressInfoFormItems" :model="detailData"></c-form-items>
        </c-info-card>
        <c-info-card title="入库信息">
          <c-form-items :showOperation="false" :items="InInfoFormItems" :model="detailData"></c-form-items>
        </c-info-card>
        <c-info-card title="出库信息">
          <c-form-items :showOperation="false" :items="OutInfpFormItems" :model="detailData"></c-form-items>
        </c-info-card>
      </el-tab-pane>
    </el-tabs>
  </el-form>
</template>

<script setup lang="ts">
import {
  _,
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  useApiRequest,
  useCurrentAppInstance,
  PageContext
} from '@zto/zpage'
import { BasicInfoFormItems, ExpressInfoFormItems, InInfoFormItems, OutInfpFormItems } from './config'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import {} from '@/config/enums'

const apiRequest = useApiRequest()
const app = useCurrentAppInstance()
const route = app.useRoute()
const shipmentCode = route.query['shipmentCode']

const fetchLoading = ref<boolean>(false)
const detailData = ref<any>({})

const operateActiveName = ref<string>('WaybillInfo')

// 详情接口请求&逻辑
const getDetailData = async () => {
  fetchLoading.value = true
  try {
    const res = await apiRequest({
      action: '/cabinet/admin/oms/AdminOmsShipmentQueryController/getDetail',
      params: {
        shipmentCode
      }
    })

    detailData.value = {
      ...res,
      productInfoData: [
        {
          productCode: res.productCode,
          productName: res.productName,
          supplierName: res.supplierName,
          productSpec: res.productSpec,
          costPrice: res.costPrice,
          salePrice: res.salePrice,
          linePrice: res.linePrice,
          shipCount: 1 // 默认是1
        }
      ]
    }

    fetchLoading.value = false
  } catch (error) {
    fetchLoading.value = false
  }
}

// 切换tab
const handleClickTab = (tab: any) => {
  switch (tab.paneName) {
    case 'WaybillInfo':
      break

    default:
      break
  }
}

const initData = () => {
  operateActiveName.value = 'WaybillInfo'
  getDetailData()
}
// 激活事件
let activeEvent: any = undefined
onMounted(() => {
  console.log('shipmentCode===', shipmentCode)
  initData()
  // 监听UI_PAGE_EVENTS.ACTIVATED（当前页激活）事件触发的回调
  activeEvent = app.ons(UI_PAGE_EVENTS.ACTIVATED, initData)
})
onBeforeUnmount(() => {
  // 解除监听UI_PAGE_EVENTS.ACTIVATED（当前页激活）事件触发的回调
  activeEvent && app.offs(activeEvent.eventTypes, activeEvent.handler)
})
</script>

<style lang="scss" scoped>
.c-cabinet-shipment-detail {
  padding: 15px;
  background: #fff;

  // 字母、数字、等 换行
  .ww-bw {
    word-wrap: break-word;
  }

  .c-action {
    margin-left: 20px;
  }
}

.m-l-20 {
  margin-left: 20px;
}
</style>

<!-- 全局样式，只针对此详情 -->
<style>
.c-cabinet-shipment-detail.el-form--label-top .el-form-item__label {
  padding: 0;
}

.c-cabinet-shipment-detail .el-input.is-disabled .el-input__inner {
  color: inherit;
  /* cursor: default; */
}

.c-cabinet-shipment-detail .el-textarea.is-disabled .el-textarea__inner {
  color: inherit;
  /* cursor: default; */
}
</style>
